import React from 'react';
import { Zap, Wifi, Car, Home, Phone, CreditCard } from 'lucide-react';
import { Header } from '../components/Layout/Header';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';

const services = [
  { id: 'electricity', name: 'Electricity', icon: Zap, color: 'bg-yellow-100 text-yellow-600' },
  { id: 'internet', name: 'Internet', icon: Wifi, color: 'bg-blue-100 text-blue-600' },
  { id: 'fuel', name: 'Fuel', icon: Car, color: 'bg-green-100 text-green-600' },
  { id: 'rent', name: 'Rent', icon: Home, color: 'bg-purple-100 text-purple-600' },
  { id: 'mobile', name: 'Mobile', icon: Phone, color: 'bg-pink-100 text-pink-600' },
  { id: 'other', name: 'Other', icon: CreditCard, color: 'bg-gray-100 text-gray-600' },
];

const recentPayments = [
  { id: '1', service: 'Electricity Bill', amount: 45.50, date: '2024-01-15', status: 'completed' },
  { id: '2', service: 'Internet Bill', amount: 29.99, date: '2024-01-14', status: 'completed' },
  { id: '3', service: 'Mobile Recharge', amount: 15.00, date: '2024-01-13', status: 'pending' },
];

export const SmartPay: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <Header title="SmartPay" showProfile={false} />
      
      {/* Balance Card */}
      <div className="p-4">
        <Card className="bg-gradient-to-r from-primary-600 to-primary-700 text-white">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-primary-100 text-sm">Available Balance</p>
              <h2 className="text-2xl font-bold">$1,750.75</h2>
            </div>
            <Button variant="ghost" className="bg-white/10 text-white hover:bg-white/20">
              Top Up
            </Button>
          </div>
        </Card>
      </div>

      {/* Services Grid */}
      <div className="px-4 mb-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Pay for Services</h3>
        <div className="grid grid-cols-3 gap-4">
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <Card key={service.id} hover className="text-center">
                <div className={`w-12 h-12 rounded-full ${service.color} flex items-center justify-center mx-auto mb-2`}>
                  <Icon size={20} />
                </div>
                <p className="text-sm font-medium text-gray-900">{service.name}</p>
              </Card>
            );
          })}
        </div>
      </div>

      {/* Quick Pay */}
      <div className="px-4 mb-6">
        <Card>
          <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Pay</h3>
          <div className="space-y-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Service Provider
              </label>
              <select className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500">
                <option>Select provider...</option>
                <option>Electric Company</option>
                <option>Internet Provider</option>
                <option>Gas Station</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Account Number
              </label>
              <input
                type="text"
                placeholder="Enter account number"
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Amount (ALGO)
              </label>
              <input
                type="number"
                placeholder="0.00"
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
            </div>
            <Button fullWidth size="lg">
              Pay Now
            </Button>
          </div>
        </Card>
      </div>

      {/* Recent Payments */}
      <div className="px-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Recent Payments</h3>
        <div className="space-y-3">
          {recentPayments.map((payment) => (
            <Card key={payment.id} hover>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-gray-900">{payment.service}</p>
                  <p className="text-sm text-gray-500">{payment.date}</p>
                </div>
                <div className="text-right">
                  <p className="font-semibold text-gray-900">${payment.amount}</p>
                  <p className={`text-sm capitalize ${
                    payment.status === 'completed' ? 'text-green-600' : 'text-yellow-600'
                  }`}>
                    {payment.status}
                  </p>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
};